import React, { useState } from 'react';
import { ModalHeader } from '../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalCloseButton } from '../../CommonComponents/OPL/Modal/ModalCloseButton';
import { Modal } from '../../CommonComponents/OPL/Modal/Modal';
import { Tab, TabList } from '../../CommonComponents/OPL/Tab';
import { Summary } from './tabs/Summary/Summary';
import { StyledTabPanel, StyledTabs } from './MyAccount.styles';
import { CloseAccountModal } from './tabs/Summary/components/CloseAccountModal/CloseAccountModal';
import { UnsavedChangesModal } from './tabs/Summary/components/UnsavedChangesModal/UnsavedChangesModal';

interface Props {
  clientId: string;
  accountId: string;
  managedAccountId: string;
  onClose(): void;
  onSuccess(): void;
}

export const MyAccount: React.FC<Props> = ({
  clientId,
  managedAccountId,
  accountId,
  onClose,
  onSuccess,
}) => {
  const [isFormDirty, setIsFormDirty] = useState(false);

  const [isUnsavedChangesModalOpen, setIsUnsavedChangesModalOpen] = useState(false);

  const [isCloseAccountModalOpen, setIsCloseAccountModalOpen] = useState(false);

  const onRequestClose = () => {
    if (isFormDirty) {
      setIsUnsavedChangesModalOpen(true);
    } else {
      onClose();
    }
  };

  return (
    <>
      <Modal
        isOpen
        onRequestClose={onRequestClose}
        isHidden={isUnsavedChangesModalOpen || isCloseAccountModalOpen}
      >
        <ModalHeader as="h2" css="margin: 0">
          My Account
        </ModalHeader>
        <ModalCloseButton onClick={onRequestClose} />

        <StyledTabs>
          <TabList px="24">
            <Tab>Summary</Tab>
          </TabList>

          <StyledTabPanel>
            <Summary
              clientId={clientId}
              accountId={accountId}
              managedAccountId={managedAccountId}
              onClose={onRequestClose}
              onSuccess={onSuccess}
              setIsFormDirty={setIsFormDirty}
              onCloseAccount={() => setIsCloseAccountModalOpen(true)}
            />
          </StyledTabPanel>
        </StyledTabs>
      </Modal>

      {isUnsavedChangesModalOpen && (
        <UnsavedChangesModal
          onDiscard={onClose}
          onCancel={() => setIsUnsavedChangesModalOpen(false)}
        />
      )}

      {isCloseAccountModalOpen && (
        <CloseAccountModal
          clientId={clientId}
          accountId={accountId}
          managedAccountId={managedAccountId}
          onClose={() => setIsCloseAccountModalOpen(false)}
          onCloseAccountSuccess={onClose}
        />
      )}
    </>
  );
};
